import { render, staticRenderFns } from "./AStar.vue?vue&type=template&id=638567da&scoped=true&"
import script from "./AStar.vue?vue&type=script&lang=js&"
export * from "./AStar.vue?vue&type=script&lang=js&"
import style0 from "./AStar.vue?vue&type=style&index=0&id=638567da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638567da",
  null
  
)

export default component.exports